
import Http from './Http'

export default {
    async getQueuesStats() {
        return await Http.get(`/monitor/queue/stats`)
    },
    async getQueueJobs(version, filter = '') {
        return await Http.get(`monitor/queue/jobs?version=${version}&all=Y${filter}`)
    },
    async getQueueSuccessJobs(version, filter = '') {
        return await Http.get(`/monitor/queue/success?version=${version}&all=Y${filter}`)
    },
    async getQueueFailedJobs(version, filter = '') {
        return await Http.get(`/monitor/queue/failed?version=${version}&all=Y${filter}`)
    },
    async retryFailedQueueJob(uuid) {
        return await Http.post(`monitor/queue/failed/retry`, uuid)
    },
    async deleteJobFromQueue(id, version) {
        return await Http.delete(`/monitor/queue/${id}?version=${version}`)
    },
    async deleteFailedQueueJob(uuid) {
        return await Http.delete(`/monitor/queue/failed/${uuid}`)
    },
    async getTenants() {
        return await Http.get(`/monitor/tenants`)
    },
    async getFeatures(params = '') {
        return await Http.get(`/monitor/features${params ? `?${params}` : ''}`)
    },
    async getTenantApplications(tenant) {
        return await Http.get(`/monitor/tenant/application?tenant=${tenant}`)
    },
    async createTenantApplication(data) {
        return await Http.post(`/monitor/application`, data)
    },
    async updateTenantApplication(id, data) {
        return await Http.post(`/monitor/application/${id}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    async deleteTenantApplication(app_id) {
        return await Http.delete(`/monitor/application/${app_id}`)
    },
    async getApiErrors() {
        return await Http.get(`/monitor/api_errors?limit=1000`)
    },
    async getCronLogs(data) {
        return await Http.get(`/monitor/api_cron_logs?${data}`)
    },
    async getExceptions() {
        return await Http.get(`/monitor/api_exceptions?limit=1000`)
    },
    async getApiAlerts() {
        return await Http.get(`/monitor/api_alerts?limit=1000`)
    },
    async updateApiAlerts(id, data) {
        return await Http.patch(`/monitor/api_alerts/${id}`, data)
    },
    async getRbacObjectRoleAccess(id = '') {
        return await Http.get(`/monitor/rbac_object_role_access?role_id=${id}`)
    },
    async getRbacRoleAccess(id = '') {
        return await Http.get(`/monitor/rbac_role_access?role_id=${id}`)
    },
    async updateRbacObjectRoleAccess(data) {
        return await Http.patch(`/monitor/rbac_object_role_access`, data)
    },
    async updateRbacRoleAccess(data) {
        return await Http.patch(`/monitor/rbac_role_access`, data)
    },
    async getRbacRoles() {
        return await Http.get(`/monitor/rbac_role`)
    },
    async getRbacAccess() {
        return await Http.get(`/monitor/rbac_access`)
    },
    async updateRbacAccess(id, data) {
        return await Http.patch(`/monitor/rbac_access/${id}`, data)
    },
    async createRbacAccess(data) {
        return await Http.post(`/monitor/rbac_access`, data)
    },
    async deleteRbacAccess(id) {
        return await Http.delete(`/monitor/rbac_access/${id}`)
    },
    async getAppParams() {
        return await Http.get(`/monitor/app/app_param_keys`)
    },
    async createAppParams(data) {
        return await Http.post(`/monitor/app/addApp_param_keys`, data)
    },
    async deleteAppParams(key) {
        return await Http.delete(`/monitor/app/deleteApp_param_keys/${key}`)
    },
    async editAppParams(data) {
        return await Http.patch(`/monitor/app/updateApp_param_keys`, data);
    },

    //Social Levels
    async getSocialLevels() {
        return await Http.get(`/monitor/social/level`)
    },
    async addSocialLevel(data) {
        return await Http.post(`/monitor/social/level`, data)
    },
    async editSocialLevel(level, data) {
        return await Http.patch(`/monitor/social/level/${level}`, data)
    },
    async deleteSocialLevel(level) {
        return await Http.delete(`/monitor/social/level/${level}`)
    },


    //Social Xp
    async getSocialxp() {
        return await Http.get(`/monitor/social/xp`)
    },
    async createSocialXp(data) {
        return await Http.post(`/monitor/social/xp`, data)
    },
    async deleteSocialXP(id) {
        return await Http.delete(`/monitor/social/xp/${id}`)
    },
    async editSocialXp(id, data) {
        return await Http.patch(`/monitor/social/xp/${id}`, data)
    },


    //Social Milestone
    async getSocialMilestones() {
        return await Http.get(`/monitor/social/milestone`)
    },
    async addSocialMilestone(data) {
        return await Http.post(`/monitor/social/milestone`, data)
    },
    async editSocialMilestone(milestone, data) {
        return await Http.patch(`/monitor/social/milestone/${milestone}`, data)
    },
    async deleteSocialMilestone(id) {
        return await Http.delete(`/monitor/social/milestone/${id}`)
    },


    //Spot Tournament
    async getAllTournament() {
        return await Http.get(`/monitor/football/tournament`)
    },

    //Sport Data Tenant Setup
    async getAllTenants(data) {
        return await Http.get(`/monitor/football/tenant`, data)
    },
    async createTenantSetup(data) {
        return await Http.post(`/monitor/football/tenant`, data)
    },
    async deleteTenantSetup(id) {
        return await Http.delete(`/monitor/football/tenant/${id}`)
    },
    async updateTenantSetup(id, data) {
        return await Http.patch(`/monitor/football/tenant/${id}`, data)
    },


    //Sport Data Tenant Tournament
    async getAllTenantsTournament(data) {
        return await Http.get(`/monitor/football/tenant_tournament`, data)
    },
    async createTenantTournament(data) {
        return await Http.post(`/monitor/football/tenant_tournament`, data)
    },
    async updateTenantTournament(data) {
        return await Http.patch(`/monitor/football/tenant_tournament`, data)
    },
    async deleteTenantTournament(data) {
        try {
            const response = await Http.delete(`/monitor/football/tenant_tournament`, {
                params: data
            });
            return response;
        } catch (error) {
            console.error("Error in DELETE request:", error);
            throw error;
        }
    },

    async getTenantDashboards() {
        return await Http.get(`/monitor/tenant/dashboard`)
    },
    async createTenantDashboard(data) {
        return await Http.post(`/monitor/dashboard`, data)
    },
    async updateTenantDashboard(tenant, data) {
        return await Http.patch(`/monitor/dashboard/${tenant}`, data)
    },
    async deleteTenantDashboard(tenant) {
        return await Http.delete(`/monitor/dashboard/${tenant}`)
    },

    async verifyTenant(data) {
        return await Http.get(`/monitor/sport_data/verify?${data}`)
    },
    async updateVersion(data) {
        return await Http.patch(`/monitor/version`, data)
    },
    async updateSSL(data) {
        return await Http.patch(`/monitor/ssl_links`, data)
    },

    // SSL Links

    async getAllSllLinks() {
        return await Http.get(`/monitor/tenant/ssl_links`)
    },
    async createTenantSSL(data) {
        return await Http.post(`/monitor/tenant/ssl_links`, data)
    },
    async updateTenantSSL(id, data) {
        return await Http.patch(`/monitor/tenant/ssl_links/${id}`, data)
    },
    async deleteTenantSSL(id) {
        return await Http.delete(`/monitor/tenant/ssl_links/${id}`)
    },
    async getMonitorPing(params = "") {
        return await Http.get(`/monitor/ping?${params}`)
    },


    async getDashboardDocumentations() {
        return await Http.get(`/monitor/dashboard_documentations`)
    },
    async createDashboardDocumentation(data) {
        return await Http.post(`/monitor/dashboard_documentation`, data)
    },
    async getRbacObjects(data) {
        return await Http.get(`/monitor/rbac_objects`, data)
    },
    async deleteDashboardDocumentation(data) {
        try {
            const response = await Http.delete(`/monitor/dashboard_documentation`, {
                params: data
            });
            return response;
        } catch (error) {
            console.error("Error in DELETE request:", error);
            throw error;
        }
    },

    //Dashboard Announcements
    async getAllDashboardMessages() {
        return await Http.get(`/monitor/dashboard_announcements`)
    },
    async createDashboardMessages(data) {
        return await Http.post(`/monitor/dashboard_announcements`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    async deleteDashboardMessages(dashboard_version) {
        return await Http.delete(`/monitor/dashboard_announcements/${dashboard_version}`)
    },
    async updateDashboardMessages(dashboard_version, data) {
        return await Http.post(`/monitor/dashboard_announcements/${dashboard_version}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },

    async getSportCompetitions(params = '') {
        return await Http.get(`/monitor/sport_competitions?${params}`)
    },
    async createSportCompetition(data) {
        return await Http.post(`/monitor/sport_competitions`, data)
    },
    async updateCompetitionLogo(id, data) {
        return await Http.patch(`/monitor/sport_competitions/${id}`, data)

    },
    async createSportTournament(data) {
        return await Http.post(`/monitor/sport_tournaments`, data)
    },
    async getSportStages(params = '') {
        return await Http.get(`/football/sport_stages?${params}`)
    },
    async createSportStage(data) {
        return await Http.post(`/monitor/sport_stages`, data)
    },
    async getMonitoredUrl() {
        return await Http.get(`/monitor/url`)
    },

    async deleteMonitoredUrl(id) {
        return await Http.delete(`/monitor/url/${id}`)
    },

    async createMonitoredUrl(data) {
        return await Http.post(`/monitor/url`, data)
    },
    // async getUrlMonitoredDetails(url_id) {
    //     return await Http.get(`/monitor/url/details/${url_id}`)
    // },
    async getUrlMonitoredDetails(url_id, timeRange = '6h') {
        return await Http.get(`/monitor/url/details/${url_id}`, {
            params: { time_range: timeRange }
        });
    },

    // YouTube
    async getYouTubeSetup() {
        return await Http.get(`/monitor/youtube_setup`)
    },
    async getChannel(tenant) {
        return await Http.get(`/monitor/channel/${tenant}`)
    },
    async createYouTubeSetup(data) {
        return await Http.post(`/monitor/youtube_setup`, data)
    },
    async deleteYouTubeSetup(id) {
        return await Http.delete(`/monitor/youtube_setup/${id}`)
    },
    async updateYouTubeSetup(id, data) {
        return await Http.patch(`/monitor/youtube_setup/${id}`, data)
    },
    async getMatches() {
        return await Http.get(`/monitor/football/matches`)
    },
    async getVPNUsers() {
        return await Http.get(`/monitor/vpn/users`)
    },
    async addVPNUsers(data) {
        return await Http.post(`/monitor/vpn/users`, data)
    },
    async removeVPNUsers(username) {
        return await Http.delete(`/monitor/vpn/users/${username}`)
    },
    async deviceStatPerTenant() {
        return await Http.get(`/monitor/device_stats`)
    },
    async editModuleAccess(data) {
        return await Http.patch(`/monitor/module/access`, data)
    },
    async getCronScheduleTasks(tenant) {
        return await Http.get(`/monitor/cron_tasks?tenant=${tenant}`)
    },
    async addCronScheduleTask(data) {
        return await Http.post(`/monitor/cron_tasks`, data)
    },
    async editCronScheduleTask(data) {
        return await Http.patch(`/monitor/cron_tasks/${data.id}`, data)
    },
    async deleteCronScheduleTask(id) {
        return await Http.delete(`/monitor/cron_tasks/${id}`)
    },
    //check email
    async checkEmail(data) {
        return await Http.get(`/monitor/check_email`, {
            params: { email: data }
        })
    },
    async callDiffScript(data, flags = '') {
        return await Http.post(`/monitor/database/diff?flags=${flags}`, data);
    },

    async requestDBCopy(data) {
        return await Http.post(`/monitor/database/copy`, data)
    },

    async getCopyData() {
        return await Http.get(`/monitor/database/copy`)
    },

    async getDiffData(src, dst, hide_ok = false, show_charset = false) {
        return await Http.get(`/monitor/database/diff?src=${src}&dst=${dst}&hide_ok=${hide_ok}&charsets=${show_charset}`);
    },

    async downloadCopy(id){
      return await Http.get(`/monitor/database/copy/download/${id}`, {responseType: 'blob'});
    },
    async deleteCopy(id){
      return await Http.delete(`/monitor/database/copy/${id}`);
    },
    async getDiffRequests(){
      return await Http.get('/monitor/database/diff/requests');
    },
    async getCronExecutionTeam(active) {
        return await Http.get(`/monitor/cron_execution_team?active=${active}`)
    },
    async getCronExecution() {
        return await Http.get(`/monitor/cron_execution`)
    },
    async addCronExecutionTeam(data) {
        return await Http.post(`/monitor/cron_execution_team`, data)
    },
    async updateCronExecutionTeam(data) {
        return await Http.patch(`/monitor/cron_execution_team`, data)
    },
    async updateCronExecution(data) {
        return await Http.patch(`/monitor/cron_execution`, data)
    },
    async getNftPacks(data) {
        return await Http.get(`/monitor/nftPacks?${data}`)
    },
    async editNft(data) {
        return await Http.patch(`/monitor/nftPacks`, data)
    },
    async getNftPackDetails(pack_id) {
        return await Http.get(`/monitor/nftPacks/${pack_id}`)
    },
    async userStatPerTenant() {
        return await Http.get(`/monitor/user_stats`)
    },
    async cronStatPerTenant() {
        return await Http.get(`/monitor/cron_stats`)
    },
    async getTenantEnvConfig(tenant) {
        return await Http.get(`/monitor/tenant/env_config?tenant=${tenant}`)
    },
    async createTenantEnvConfigDefinition(data) {
        return await Http.post(`/monitor/tenant/env_config/definition`, data)
    },
    async createTenantEnvConfig(data) {
        return await Http.post(`/monitor/tenant/env_config`, data)
    },
    async editTenantEnvConfig(data) {
        return await Http.patch(`/monitor/tenant/env_config`, data)
    },
    async getEnvConfigDefinition(data) {
        return await Http.get(`/monitor/tenant/env_config/definition?${data}`)
    },
    async removeEnvConfig(key, tenant) {
        return await Http.delete(`/monitor/tenant/env_config/${key}?tenant=${tenant}`)
    },
    async getMissingEnvConfig(tenant) {
        return await Http.get(`/monitor/tenant/env_config/missing?tenant=${tenant}`)
    },
    async editEnvConfigDefinition(data) {
        return await Http.patch(`/monitor/tenant/env_config/definition`, data)
    },
    async getTenantProfileFieldsConfig(tenant, appId = '') {
        let url = `/monitor/tenant/profileFieldsConfig?tenant=${tenant}`
        if (appId) {
            url += `&app_id=${appId}`
        }
        return await Http.get(url)
    },
    async updateTenantProfileFieldsConfig(data) {
        return await Http.patch(`/monitor/tenant/profileFieldsConfig`, data)
    },
    async getProfileContextDefinitions(active = '') {
        let url = `/monitor/profileFields/context/definition`
        if (active !== '') {
            url += `?active=${active}`
        }
        return await Http.get(url)
    },
    async createProfileContextDefinition(data) {
        return await Http.post(`/monitor/profileFields/context/definition`, data)
    },
    async updateProfileContextDefinition(data) {
        return await Http.patch(`/monitor/profileFields/context/definition`, data)
    },
    async deleteProfileContextDefinition(name) {
        return await Http.delete(`/monitor/profileFields/context/definition/${encodeURIComponent(name)}`)
    },
    async getProfileFieldsDefinitions(active = '') {
        let url = `/monitor/profileFields/field/definition`
        if (active !== '') {
            url += `?active=${active}`
        }
        return await Http.get(url)
    },
    async createProfileFieldsDefinition(data) {
        return await Http.post(`/monitor/profileFields/field/definition`, data)
    },
    async updateProfileFieldsDefinition(data) {
        return await Http.patch(`/monitor/profileFields/field/definition`, data)
    },
    async deleteProfileFieldsDefinition(name) {
        return await Http.delete(`/monitor/profileFields/field/definition/${encodeURIComponent(name)}`)
    },

}